import { render, staticRenderFns } from "./pdTabs.vue?vue&type=template&id=0e75a2c6&scoped=true"
import script from "./pdTabs.vue?vue&type=script&lang=js"
export * from "./pdTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e75a2c6",
  null
  
)

export default component.exports